import { CommonModule } from '@angular/common';
import { Component, input, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { type NavigationLink } from '@protctc/common/core/models/navigation-link';
import { BreadcrumbsService } from '@protctc/common/core/services/breadcrumbs.service';

/** Breadcrumbs. */
@Component({
	selector: 'protctw-breadcrumbs',
	templateUrl: './breadcrumbs.component.html',
	styleUrls: ['./breadcrumbs.component.css'],
	imports: [RouterModule, CommonModule],
})
export class BreadcrumbsComponent {
	private readonly breadcrumbsService = inject(BreadcrumbsService);

	private readonly router = inject(Router);

	/** Links for breadcrumbs. */
	public readonly links = input<readonly NavigationLink[]>([]);

	/** Breadcrumbs. */
	protected readonly breadcrumbs$ = this.breadcrumbsService.breadcrumbs$;

	/**
	 * Define is base url or url with query is active link.
	 * We can't use routerLinkActive directive directly,
	 * because without `exact` parent breadcrumb link is active too,
	 * but with `exact` parameter - link with query params is not active.
	 * @param url Url.
	 */
	protected isLinkActive(url: string): boolean {
		const queryParamsIndex = this.router.url.indexOf('?');
		const baseUrl = queryParamsIndex === -1 ? this.router.url : this.router.url.slice(0, queryParamsIndex);
		return baseUrl === url;
	}
}
